import SortIcon from "../SortIcon/SortIcon";
import type { BookExtractHeader } from "./types";
import type { SortState } from "../BookExtracts/types";

interface SortableHeaderProps {
  header: BookExtractHeader;
  sort: SortState | null;
  onSort: (key: string) => void;
}

function SortableHeader({ header, sort, onSort }: SortableHeaderProps) {
  const isActive = sort?.key === header.key;

  if (!header.sortable) {
    return <th scope="col">{header.label}</th>;
  }

  return (
    <th
      scope="col"
      aria-sort={
        isActive
          ? sort?.direction === "asc"
            ? "ascending"
            : "descending"
          : "none"
      }
    >
      <button
        type="button"
        className={`book-table__sort-button${
          isActive ? " book-table__sort-button--active" : ""
        }`}
        onClick={() => onSort(header.key)}
      >
        {header.label}
        <SortIcon direction={isActive ? sort?.direction ?? null : null} />
      </button>
    </th>
  );
}

export default SortableHeader;
